import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from 'gatsby';

const ButtonStyled = styled.div`
    display: inline-block;
    background-color: ${(props) =>
        props.isPrimary
            ? props.theme.colors.buttons.primary
            : props.theme.colors.buttons.secondary};
    border-radius: ${(props) => props.theme.borderRadius.default};
    cursor: pointer;

    &:hover {
        background-color: ${(props) =>
            props.isPrimary
                ? props.theme.colors.buttons.primaryHover
                : props.theme.colors.buttons.secondaryHover};
    }

    a,
    button {
        display: block;
        width: 100%;
        height: 100%;
        text-align: center;
        padding: ${(props) => `${props.verticalPadding} ${props.sidePadding}`};
        color: #fff;
        font: 12px ${(props) => props.theme.fonts[0]}, sans-serif;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    }

    button {
        background-color: transparent;
        border: none;
    }
`;

export default function Button({
    className,
    clicked,
    isExternal,
    isLink,
    isPrimary,
    linkURL,
    sidePadding,
    verticalPadding,
    text,
}) {
    return (
        <ButtonStyled
            className={className ? className : undefined}
            sidePadding={sidePadding}
            isPrimary={isPrimary}
            verticalPadding={verticalPadding}
        >
            {!isLink ? (
                <button onClick={clicked}>{text}</button>
            ) : !isExternal ? (
                <Link to={linkURL}>{text}</Link>
            ) : (
                <a href={linkURL} target="_blank" rel="noopener noreferrer">
                    {text}
                </a>
            )}
        </ButtonStyled>
    );
}

Button.propTypes = {
    className: PropTypes.string,
    clicked: PropTypes.func,
    isExternal: PropTypes.bool,
    isLink: PropTypes.bool,
    isPrimary: PropTypes.bool,
    linkURL: PropTypes.string,
    sidePadding: PropTypes.string,
    veritcalPadding: PropTypes.string,
    text: PropTypes.string.isRequired,
};

Button.defaultProps = {
    isExternal: false,
    isLink: true,
    isPrimary: true,
    linkURL: '',
    sidePadding: '32px',
    verticalPadding: '16px',
};
